/* ============
 * MerchantTransformer
 * ============
 *
 * todo: add documentation here!
 */

import moment from 'moment'

import Transformer from './Transformer'

export default class MerchantTransformer extends Transformer {
  static fetch (item) {
    return {
      id: item['merchant_id'],
      name: item['merchant_name'],
      createdAt: moment.unix(item['created_date']).format('YYYY-MM-DD'),
      updatedAt: item['updated_date'] ? moment.unix(item['updated_date']).format('YYYY-MM-DD') : null,
      mcIds: item['mc_merchant_ids'],
      items: item['items']
    }
  }

  static send (item) {
    return {
      //
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/MerchantTransformer.js